var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{staticClass:"font-weight-600 custom-barcode",class:{ 'my-1': !_vm.dense, 'cursor-pointer': _vm.id, 'cursor-default': !_vm.id },attrs:{"color":"chip-custom-blue","outlined":"","label":"","small":_vm.small},on:{"click":_vm.pushToDetail}},[_vm._v(" "+_vm._s(_vm.barcode)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }